import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20romantic%20scene%20couple%20standing%20under%20cherry%20blossom%20tree%20at%20golden%20hour%20warm%20soft%20sunlight%20petals%20dancing%20in%20air%20dreamy%20atmosphere%20beautiful%20cinematic%20composition%20manhwa%20art%20style&width=1800&height=800&seq=cta-bg-home&orientation=landscape"
          alt="韩漫之家 - 立即开始阅读"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
          海量高清韩漫，免费畅读
        </h2>
        <p className="mt-4 text-sm md:text-base text-background-50/70 max-w-xl mx-auto leading-relaxed">
          无论是热血的战斗、甜蜜的恋爱还是烧脑的悬疑，在韩漫之家你都能找到心仪的作品
        </p>
        <div className="mt-8">
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开启阅读之旅
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-up-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}